import ApiService from "@/common/api/api.service";

const ProjecaoFinanceira = {
    selecao : function(empresaId){
        return ApiService.get(`ProjecaoFinanceira/selecao?EmpresaId=${empresaId}`)
    },
    salvos : function(id){
        return ApiService.get(`ProjecaoFinanceira/salvos?id=${id}`)
    },
    simular : function(form){
        return ApiService.post(`ProjecaoFinanceira/simular`, form)
    },
    salvar : function(form){
        return ApiService.post(`ProjecaoFinanceira/salvar`, form)
    },
    


};

export default ProjecaoFinanceira;
